<template>
  <div class="popover">
    <div  class="popover_inner">
      <div @click="closePopup" class="popover_close">Close X</div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import CabinetControl from './CabinetControl'
import FabricControl from './FabricControl'

export default {
  props: [ 'controltype' ],
  components : {
    CabinetControl,
    FabricControl
  },
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      msg: 'Hello World!'
    }
  },
  methods : {
    
   
    closePopup () {
      this.$dispatch( 'popup-closed' )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




/** WEBPACK FOOTER **
 ** popover.vue?024c2a17
 **/